import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 15px;
  height: 14px;
  color: #ffffff;
`

const Info = ({ title = 'Information', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 15 14" title={title} {...rest}>
    <g id="Install-Connector-Form-3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Install-Connector---catalog" transform="translate(-717.000000, -346.000000)">
        <g id="content-copy-3">
          <g id="custom-connectors" transform="translate(310.000000, 106.000000)">
            <g id="chrome-river" transform="translate(0.995842, 11.000000)">
              <g id="Create-New-content" transform="translate(256.000000, 39.000000)">
                <g id="Form-input-component" transform="translate(40.000000, 188.000000)">
                  <g id="info-icon-" transform="translate(111.000000, 3.000000)">
                    <rect id="Rectangle-path" className="info-icon-rect" x="0" y="-1" width="14" height="14" />
                    <polyline
                      id="Shape"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="square"
                      points="6 6 7 6 7 9"
                    />
                    <path d="M6,9 L8,9" id="Shape" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" />
                    <circle id="Oval" fill="currentColor" fillRule="nonzero" cx="7" cy="3" r="1" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </StyledIcon>
)

Info.displayName = 'Info'
Info.needsWork = true
export default Info
